class ApiService {
	constructor(baseURL, graphURL) {
		this.baseURL = baseURL;
		this.graphURL = graphURL;
	}

	async request(method, endpoint, headers = {}, data = null, graph = false) {
		let url = "";
		if (!graph)
			url = `${this.baseURL}${endpoint}`; // URL di base
		else url = `${this.graphURL}`;

		// Automatically add Authorization header if token exists and not already present
		const token = localStorage.getItem("token");
		const mergedHeaders = {
			"Content-Type": "application/json",
			...headers,
		};
		if (token && !mergedHeaders["Authorization"]) {
			mergedHeaders["Authorization"] = `Bearer ${token}`;
		}

		const options = {
			method: method,
			headers: mergedHeaders,
		};

		if (data) {
			options.body = JSON.stringify(data); // Aggiungi il body solo se ci sono dati
		}

		try {
			let response = await fetch(url, options);

			if ((response.status === 401 || response.status === 403) && localStorage.getItem("refresh")) {
				console.log("refresh", localStorage.getItem("refresh"));
				const refreshResponse = await fetch(`${this.baseURL}/login/refresh/`, {
					method: "POST",
					headers: { "Content-Type": "application/json" },
					body: JSON.stringify({
						refresh: localStorage.getItem("refresh"),
					}),
				});

				console.log("refreshResponse", refreshResponse);

				if (refreshResponse.ok) {
					const refreshData = await refreshResponse.json();
					localStorage.setItem("token", refreshData.access);

					// Retry the original request with new token
					options.headers["Authorization"] = `Bearer ${refreshData.access}`;
					response = await fetch(url, options);
				} else {
					// Refresh failed, log out
					localStorage.clear();
					window.location.href = "/auth/login";
					throw new Error("Session expired. Please log in again.");
				}
			}

			if (!response.ok) {
				const errorData = await response.json(); // Legge la risposta JSON
				throw new Error(errorData.error || `HTTP error! Status: ${response.status}`);
			}

			// Controlla se c'è contenuto prima di fare il parsing JSON
			const contentType = response.headers.get("content-type");
			if (contentType && contentType.includes("application/json")) {
				const text = await response.text();
				return text ? JSON.parse(text) : null;
			} else {
				// Se non c'è JSON, restituisci null o un oggetto vuoto
				return null; // o return {};
			}
		} catch (error) {
			throw error;
		}
	}

	get(endpoint, params = {}, headers = {}) {
		if (params) {
			const queryString = new URLSearchParams(params).toString();
			const urlWithParams = queryString ? `${endpoint}?${queryString}` : endpoint;
			return this.request("GET", urlWithParams, headers);
		} else {
			return this.request("GET", endpoint, headers);
		}
	}

	post(endpoint, headers, data, graph = false) {
		return this.request("POST", endpoint, headers, data, graph);
	}

	put(endpoint, headers, data) {
		return this.request("PUT", endpoint, headers, data);
	}

	patch(endpoint, headers, data) {
		return this.request("PATCH", endpoint, headers, data);
	}

	delete(endpoint, params = {}, headers) {
		const queryString = new URLSearchParams(params).toString();
		const urlWithParams = queryString ? `${endpoint}?${queryString}` : endpoint;
		return this.request("DELETE", urlWithParams, headers);
	}
}

// Esporta l'istanza della classe ApiService
const apiService = new ApiService(
	window.location.hostname.split(".")[0] !== "localhost"
		? `https://${window.location.hostname.split(".")[0]}.helpmate.it/api`
		: process.env.REACT_APP_API_URL_BACKEND,
	process.env.REACT_APP_HASURA_HOST
);

export default apiService;
